import { useEffect, useState } from 'react';
import LogoutModal from './LogoutModal';
import { useAppState } from '../state/useAppState';

const AuthSetup = ({ children }: { children: JSX.Element[] }) => {
    const [noTokenFound, setNoTokenFound] = useState(false);
    const setToken = useAppState(state => state.setToken);
    const token = useAppState(state => state.token);
    const authError = useAppState(state => state.authError);

    useEffect(() => {
        const fetchToken = async () => {
            const search = new URLSearchParams(window.location.search);
            const tokenParam = search.get('token');

            if (tokenParam) {
                await setToken(tokenParam);
            } else {
                setNoTokenFound(true);
            }
        };

        if (!token) {
            fetchToken();
        }
    }, [setToken, token]);

    if (noTokenFound || authError) {
        return <LogoutModal />;
    }

    return children;
};

export default AuthSetup;
